module.exports = __webpack_public_path__ + "img/nodata.2e7118fb.png";